module.exports = __webpack_public_path__ + "img/3diamonds.62fa31cc.jpg";